import { createAction, props } from '@ngrx/store';

import { Referral } from '@shared/models';

export const referralGet = createAction(
  '[Referral] Get',
  props<{referralId: number}>(),
);

export const referralGetSuccess = createAction(
  '[Referral] Get Success',
  props<{referral: Referral}>(),
);

export const referralGetFailure = createAction(
  '[Referral] Get Failed',
  props<{error: any}>(),
);
